"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporationType = void 0;
var CorporationType;
(function (CorporationType) {
    CorporationType["llc"] = "llc";
    CorporationType["sole_proprietor"] = "sole_proprietor";
    CorporationType["non_profit"] = "non_profit";
    CorporationType["partnership"] = "partnership";
    CorporationType["cooperative"] = "cooperative";
    CorporationType["s_corporation"] = "s_corporation";
    CorporationType["c_corporation"] = "c_corporation";
    CorporationType["b_corporation"] = "b_corporation";
})(CorporationType || (exports.CorporationType = CorporationType = {}));
